import React from "react";
import {
    useAcceptAndContinueSearchMutation,
    useAcceptAndStopSearchMutation,
    useDeclineOfferOrderMutation,
} from "../../../../../store/chat/chat.api";
import { IOffer } from "../../../../../models/ordersModel";
import { TranslationObject } from "../../../../../models/translationModal";
import { useNotification } from "../../../../../hooks/useNotification/useNotification";

interface CustomerButtonsProps {
    offer: IOffer | null;
    entities?: TranslationObject;
    handleMakeOfferFromCustomer: () => Promise<void>;
    status?: string;
}

export const CustomerButtons: React.FC<CustomerButtonsProps> = ({
    offer,
    entities,
    handleMakeOfferFromCustomer,
    status = "",
}) => {
    const { id } = offer || {};

    const { setNotification } = useNotification();

    const [acceptAndContinueSearch] = useAcceptAndContinueSearchMutation();

    const [acceptAndStopSearch] = useAcceptAndStopSearchMutation();

    const [declineOfferOrder] = useDeclineOfferOrderMutation();

    const actionHandlers = {
        AcceptAndContinue: acceptAndContinueSearch,
        AcceptAndStop: acceptAndStopSearch,
        DeclineOffer: declineOfferOrder,
    };

    const showOfferButton = offer?.proposed_by === null || !offer || Object.keys(offer).length === 0;
    const showAcceptRejectButtons =
        offer && typeof id === "number" && offer.proposed_by === "specialist" && status === "active";

    const handleClickButton: (params: {
        offerId: number;
        action: "AcceptAndContinue" | "AcceptAndStop" | "DeclineOffer";
    }) => void = ({ offerId, action }) => {
        actionHandlers[action](offerId)
            .unwrap()
            .catch((err) =>
                setNotification({
                    type: "warn",
                    title: err?.data?.payload?.title ?? "",
                    description:
                        err?.data?.payload?.message ??
                        err?.data?.description ??
                        "",
                })
            );
    };

    return (
        <>
            {showOfferButton && (
                <div className="order-action-panel-offer">
                    <p className="order-action-panel-offer__text">
                        {entities?.customer_chat_agreement_confirmation?.value
                            ? entities?.customer_chat_agreement_confirmation?.value
                            : "Click when you have agreed to the terms of the order."}
                    </p>
                    <button
                        className="button button--customer-offer"
                        type="button"
                        onClick={handleMakeOfferFromCustomer}
                    >
                        {entities?.order_offer_a_deal?.value}
                    </button>
                    <span className="popover__tip">
                        {entities?.order_offer_disclosure_request?.value}
                    </span>
                </div>
            )}
            {showAcceptRejectButtons && (
                <div className="form__row chat__controls">
                    <div className="order-action-panel-agreement-disagreement order-action-panel-agreement-disagreement-customer">
                        <div className="popover popover--grey">
                            <button
                                className="button button--customer-accept-continue-search"
                                onClick={() =>
                                    handleClickButton({
                                        offerId: id,
                                        action: "AcceptAndContinue",
                                    })
                                }
                            >
                                {
                                    entities
                                        ?.order_offer_accept_and_continue_search
                                        ?.value
                                }
                            </button>
                            <span className="popover__tip">
                                {
                                    entities
                                        ?.order_offer_accept_and_continue_search_info
                                        ?.value
                                }
                            </span>
                        </div>
                        <div className="popover popover--grey">
                            <button
                                className="button button--customer-accept-stop-search"
                                type="button"
                                onClick={() =>
                                    handleClickButton({
                                        offerId: id,
                                        action: "AcceptAndStop",
                                    })
                                }
                            >
                                {
                                    entities?.order_offer_accept_and_stop_search
                                        ?.value
                                }
                            </button>
                            <span className="popover__tip">
                                {
                                    entities
                                        ?.order_offer_accept_and_stop_search_info
                                        ?.value
                                }
                            </span>
                        </div>
                        <div className="popover popover--grey">
                            <button
                                className="button button--customer-disagreement"
                                type="button"
                                onClick={() =>
                                    handleClickButton({
                                        offerId: id,
                                        action: "DeclineOffer",
                                    })
                                }
                            >
                                {entities?.common_decline?.value}
                            </button>
                            <span className="popover__tip">
                                {entities?.order_offer_reject_info?.value}
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
